<template>
  <div id="payl8r-repayment-calculator-content">
    <div class="payl8r-repayment-calculator-header inter-bold">
      Repayment plan calculator
    </div>
    <ul class="repay-months-wrapper">
      <li v-for="(value, key) in installmentsInfo" :key="key" class="repay-month-boxes">
        <RepayMonthBox :month='key' :repayment='value' :class='key'></RepayMonthBox>
      </li>
    </ul>
    <RepayGeneralInfo :deposit-amount="deposit" :amount="amount"></RepayGeneralInfo>
    <p class="repay-month-info">*Rates, totals and monthly payment amounts are indicative and are subject to status and
      assume that you pay a deposit of &pound;{{(Math.round(deposit * 100) / 100).toFixed(2)}} on checkout.</p>
  </div>
</template>
<script>
import RepayMonthBox from "@/components/repayMonthBox";
import RepayGeneralInfo from "@/components/repayGeneralInfo.vue";

export default {
  components: {
    RepayGeneralInfo,
    'RepayMonthBox': RepayMonthBox,
  },
  props: {
    installmentsInfo: Object,
    repExample: Object,
    deposit: Number,
    amount: Number
  },
}
</script>
